import './main.css';
import { showCorrectLoader } from 'common/utils/loader';

document.addEventListener('DOMContentLoaded', () => {
    showCorrectLoader();
    initLoadingImage();
});

/**
 * Loads a loading image.
 * @param name
 */
function loadLoadingImage(name: string) {
    const im = new Image();
    im.src = 'images/' + name;
    im.width = 800;
    im.height = 800;
    document.getElementById('place-loading-animation-here')?.appendChild(im);
}

/**
 * Initializes the loading image based on AVIF support and browser type.
 * Attempts to load a small AVIF image to detect support.
 * If AVIF is supported and the browser is not Firefox, loads an AVIF loading image.
 * If AVIF is not supported or the browser is Firefox, falls back to a PNG loading image.
 *
 */
function initLoadingImage() {
    const avif = new Image();
    avif.src =
        'data:image/avif;base64,AAAAIGZ0eXBhdmlmAAAAAGF2aWZtaWYxbWlhZk1BMUIAAADybWV0YQAAAAAAAAAoaGRscgAAAAAAAAAAcGljdAAAAAAAAAAAAAAAAGxpYmF2aWYAAAAADnBpdG0AAAAAAAEAAAAeaWxvYwAAAABEAAABAAEAAAABAAABGgAAAB0AAAAoaWluZgAAAAAAAQAAABppbmZlAgAAAAABAABhdjAxQ29sb3IAAAAAamlwcnAAAABLaXBjbwAAABRpc3BlAAAAAAAAAAIAAAACAAAAEHBpeGkAAAAAAwgICAAAAAxhdjFDgQ0MAAAAABNjb2xybmNseAACAAIAAYAAAAAXaXBtYQAAAAAAAAABAAEEAQKDBAAAACVtZGF0EgAKCBgANogQEAwgMg8f8D///8WfhwB8+ErK42A=';
    avif.onload = function () {
        loadLoadingImage('LoginAnimation.gif');
    };
    avif.onerror = function () {
        loadLoadingImage('BRS.png');
    };
}
